import * as React from 'react';
import type { Document } from '@contentful/rich-text-types';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import {
  documentToReactComponents,
  type Options,
} from '@contentful/rich-text-react-renderer';
import { Bold, Italic, Meta } from '@mentimeter/content-ui/Typography';
import { Link } from 'src/ui/actions';

const options: Options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <Bold>{text}</Bold>,
    [MARKS.ITALIC]: (text) => <Italic>{text}</Italic>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <Meta>{children}</Meta>,
    [INLINES.HYPERLINK]: (node, children) => (
      <Link href={node.data.uri}>{children}</Link>
    ),
  },
};

interface Props {
  document: Document;
}

export function CaptionRenderer({ document }: Props): any {
  return documentToReactComponents(document, options);
}
